import React from "react";
import { withStyles } from "@material-ui/core";
import Dialog from "../../../../components/Dialog/Dialog";
import { valores } from "./constants";
import ValorPropaganda from "./components/ValorPropaganda";
import { Button } from "../../../../components/ui/Buttons";

const ModalEvahIaPropaganda = ({ classes, open, onClose }) => {
  const openPagamento = () => {
    const profissionalLogado = JSON.parse(localStorage[`_immortal|profissional_saude_logado`] || null);

    const urlComercial = process.env.REACT_APP_COMERCIAL_URL;
    const url = `${urlComercial}/pagamento-ia-profissional?idProfissional=${profissionalLogado.id}`;

    window.open(url, "_blank");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      maxWidth="md"
      fullWidth
    >
      <div className={classes.modalContent}>
        <div className={classes.header}>
          <h1 className={classes.headerTitle}>IA no prontuário</h1>
        </div>

        <div className={classes.content}>
          <div className={classes.contentValores}>
            <div className={classes.textContent}>
              <p className={classes.description}>
                Agilize seus atendimentos, reduza o tempo de registro e dedique
                mais atenção ao seu paciente.
              </p>
            </div>
            <div className={classes.contentValorPropaganda}>
              {valores.map(({ label, valor, unidade, riscado }) => {
                return (
                  <ValorPropaganda
                    label={label}
                    valor={valor}
                    unidade={unidade}
                    riscado={riscado}
                  />
                );
              })}
            </div>
            <div className={classes.contentButton}>
              <Button id="prt-eip-btn-ctr" bgColor="#A082ED" onClick={openPagamento}>
                Contrate agora!
              </Button>
            </div>
          </div>
          <div className={classes.contentVideo}>
            <iframe
              className={classes.video}
              src="https://www.youtube-nocookie.com/embed/reWNFf5ctMM?rel=0&modestbranding=1"
              title="IA no prontuário"
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    height: "64px",
    background: "#26ACA9",
    paddingLeft: "24px",
  },
  headerTitle: {
    color: "#fff",
    fontSize: "24px",
  },
  dialogPaper: {
    height: "500px",
    maxWidth: "880px",

    "& > div": {
      height: "100%",
    },
  },
  content: {
    display: "flex",
    flexDirection: "row",
    height: "calc(100% - 64px)",
  },
  description: {
    color: "#505050",
  },
  contentValores: {
    flex: 1,
    padding: "24px",
  },
  contentValorPropaganda: {
    display: "flex",
    gap: "8px",
    flexDirection: "column",
  },
  contentButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: "24px",
  },
  contentVideo: {
    display: "flex",
    flex: 3,
    padding: "48px 24px",
    background: "#C4C4C4",
    position: "relative",
    overflow: "hidden",
  },
  video: {
    width: "100%",
  },
};

export default withStyles(styles)(ModalEvahIaPropaganda);
